import { TitleButton } from '@/common/buttons/TitleButton';
import { useEntityFromRoute } from '@/common/hooks/route/useEntityFromRoute';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { usePrincipal } from '@/common/principal/PrincipalContext';
import { far } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEntityMgr } from '../entityView/EntityMgrContext';
import { EntityFormMode } from '../enumerations/EntityFormMode';

export const EntityEditButton = () => {
  const { hist, asOfDate, entityFormMode, setEntityFormMode } = useEntityMgr();
  const module = useModuleFromRoute();
  const entity = useEntityFromRoute();

  // Only render if the use has appropriate Role
  const { hasRole } = usePrincipal();
  if (!hasRole(`${module.toUpperCase()}_${entity}_SAVE`)) return;

  return (
    <TitleButton
      icon={far.faPencil}
      toolTip="Edit"
      onClick={() => setEntityFormMode(EntityFormMode.EDIT)}
      disabled={[EntityFormMode.ADD, EntityFormMode.EDIT].includes(entityFormMode) || hist || asOfDate}
    />
  );
};
